<template>
  <div
    class="align-items-center d-flex flex-fill justify-content-center"
    :class="height"
  >
    <span
      class="spinner-border spinner-border text-primary"
      role="status"
      aria-hidden="true"
    ></span>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    height?: string;
  }>(),
  {
    height: "vh-50",
  },
);
</script>

<style scoped>
.vh-50 {
  height: 50vh;
}
</style>
